import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { MenuItem } from '@mui/material'

import keys from '@/utils/keys'
import { ReportsType } from '@/enums/reports-type.enum'
import { ADMIN_VIEW } from '@/constants/brand'

import { ApplicationState } from '@/state/root.models'
import InputFormikField from '@/views/components/input-formik-field/index.component'

type Props = {
  handleChangeSearch: (field: string, value: any) => void
}

const ReportTypeFilter = ({ handleChangeSearch }: Props) => {
  const { t } = useTranslation()

  const { brand } = useSelector(({ auth }: ApplicationState) => auth)

  const reportTypes = [
    ...keys(ReportsType)
      .filter(
        (item) =>
          (brand.siteId !== ADMIN_VIEW && ReportsType[item] !== '6') ||
          brand.siteId === ADMIN_VIEW,
      )
      .map((x) => {
        return {
          index: ReportsType[x],
          value: x,
        }
      }),
  ].sort((a, b) => a.value.localeCompare(b.value))

  const reportsOptions = reportTypes.map((report) => {
    return (
      <MenuItem key={report.index} value={report.index}>
        {t(`reports.reportsTypeOptions.${report.value}`)}
      </MenuItem>
    )
  })

  return (
    <InputFormikField
      name="reportType"
      label={t('reports.reportTypeLabel')}
      select
      required
      margin="dense"
      onChange={(event) => handleChangeSearch('reportType', event.target.value)}
    >
      {reportsOptions}
    </InputFormikField>
  )
}
export default ReportTypeFilter
